import { StatusBar } from 'expo-status-bar';
import { StyleSheet, View, Image, TextInput, TouchableWithoutFeedback, ActivityIndicator, SafeAreaView, ScrollView, Pressable, Text, Picker, Platform, findNodeHandle } from 'react-native';
import { useState, useEffect, useRef } from 'react';
import * as ImagePicker from 'expo-image-picker';
import { doc, collection, setDoc, addDoc, Timestamp, updateDoc } from "firebase/firestore";
import { FAB, Chip, IconButton } from "@react-native-material/core";
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import {GooglePlacesAutocomplete} from 'react-native-google-places-autocomplete';
// import { ref, uploadBytes, uploadString, getDownloadURL } from "firebase/storage";
import * as Location from 'expo-location';
import Ionicons from '@expo/vector-icons/Ionicons';

import { db } from '../firebaseConfig';
//import { storage } from '../firebaseConfig';
const geofire = require('geofire-common');

import Button from '../components/shared/Button';
import ConfirmModal from '../components/ConfirmModal'
import ImageViewer2 from '../components/ImageViewer2';
import WebCameraCapture from '../components/WebCameraCapture';
import PhotoSourceModal from '../components/PhotoSourceModal';
import { getLocation, getImageDimensions }  from '../services/utils/General'
import { saveImage }  from '../services/storage/Storage'
import { getUserDataByUserId, getBarNamesByBusinessIds, getBusinessDetails }  from '../services/users/Users';

const PlaceholderImage = require('../assets/images/select-image-2.png');


/* todo decide if we want to do 
class Post {
  constructor (comment) {
      this.comment = comment;
      // pass in more params when ready
      //this.state = state;
      //this.country = country;
  }
  toString() {
      return this.comment;// + ', ' + this.state + ', ' + this.country;
  }
}

// Firestore data converter
const postConverter = {
  toFirestore: (post) => {
      return {
          name: post.comment//,
          // state: post.state,
          // country: post.country
          //created: Timestamp.now()
          };
  },
  fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new Post(data.comment); //, data.state, data.country);
  }
};
*/


export default function PostScreen({ route, navigation }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImage2, setSelectedImage2] = useState(null);
  const [selectedImage3, setSelectedImage3] = useState(null);
  const [text, setText] = useState('');
  const [bar, setBar] = useState('');
  const [tags, setTags] = useState([]);
  const [tag, setTag] = useState('');
  const [animating, setAnimating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [postId, setPostId] = useState(false);
  const [isNewImage, setIsNewImage] = useState(false);
  const [isNewImage2, setIsNewImage2] = useState(false);
  const [isNewImage3, setIsNewImage3] = useState(false);
  const [location, setLocation] = useState(null);
  //const { data } = route.params ?? null;
  const ref = useRef(null);
  const refBar = useRef(null);
  const scrollViewRef = useRef(null);
  const barContainerRef = useRef(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);
  const [showChooseMorePhotos, setShowChooseMorePhotos] = useState(false);
  const [googlePlacesDetails, setGooglePlacesDetails] = useState(null);
  const [businessesForUser, setBusinessesForUser] = useState([]);
  const [selectedBusinessId, setSelectedBusinessId] = useState('');
  // business users can opt out of notifying users who favorited the bar
  const [sendNotification, setSendNotification] = useState(true);
  // null when hidden, otherwise which image slot (1, 2, or 3) the camera capture is for
  const [webCameraTarget, setWebCameraTarget] = useState(null);
  // null when hidden, otherwise which image slot (1, 2, or 3) the "Add a photo" chooser is for
  const [photoSourceTarget, setPhotoSourceTarget] = useState(null);

  useEffect(() => {
    (async () => {

      let savedUserId = window.localStorage.getItem('userId');
      if (!savedUserId) {
        alert("Sign in to create a post");
        navigation.navigate('CreateAccountScreen');
      }

      //alert("username:" + window.localStorage.getItem('username'));

      //console.log("route.params.data", route.params.data);

      // Load user's businesses first
      var userInfo = await getUserDataByUserId(savedUserId);
      let businesses = [];
      if (userInfo && userInfo.businessIds && userInfo.businessIds.length > 0) {
        var barNames = await getBarNamesByBusinessIds(userInfo.businessIds);
        setBusinessesForUser(barNames);
        businesses = barNames;
        navigation.setOptions({ title: 'Create a business post' });
      }

      // Then load post data if editing
      if (route != null && route.params != null && route.params.data != null && route.params.data.data.userId == savedUserId) {
        var data = route.params.data.data;
        setIsUpdating(true);
        setPostId(route.params.data.id);
        navigation.setOptions({ title: 'Edit post' });
        // this is "late", setIsUpdating sets the value ...console.log("is editing", isUpdating);
        if (data.storageImageUrl) {
          setSelectedImage(data.storageImageUrl);
        }
        if (data.storageImageUrl2) {
          setSelectedImage2(data.storageImageUrl2);
          setShowChooseMorePhotos(true);
        }
        if (data.storageImageUrl3) {
          setSelectedImage3(data.storageImageUrl3);
          setShowChooseMorePhotos(true);
        }
        setText(data.comment);
        setTags(data.tagsArray);
        
        // If user has businesses, find and select the matching one
        if (businesses && businesses.length > 0) {
          const matchingBusiness = businesses.find(b => b.bar === data.bar);
          if (matchingBusiness) {
            setSelectedBusinessId(matchingBusiness.id);
          }
        } else {
          // Only use GooglePlaces if user doesn't have businesses
          refBar.current.setAddressText(data.bar);
        }
        setDeleteOption();
      }

      //var locationResult = await getLocation();
      // console.log("location:", route.params.location);
      if (route.params.location) {
        setLocation(route.params.location);
      }

      // else
      // {      
      //   const [status, requestPermission] = Location.useForegroundPermissions();
      //   console.log("status:", status);
      //   console.log("requestPermission:", requestPermission);
      // }

    })();
  }, [])

  const deletePost = async () => {
    setIsDeleteConfirmVisible(true);
  }

  const closePopup = async () => {
    setIsDeleteConfirmVisible(false);
  }

  const confirmDeletePost = async () => {

    // console.log('confirmDeletePost');

    const postRef = doc(db, "Posts", postId);
    await updateDoc(postRef, {
        status: ['softdeleted']
    });

    setIsDeleteConfirmVisible(false);

    navigation.navigate({
      name: 'HomeScreen',
      params: { shouldRefresh: true },
      merge: true,
    });
  }


  async function setDeleteOption() {
    navigation.setOptions({
      headerRight: () => (
        <Pressable onPress={deletePost} style={{ paddingRight: 15 }}>
          <Ionicons name="trash-outline" size={30} color="#25292e" />
        </Pressable>
      )
    });
  }

  // launches the camera or the photo library depending on the useCamera flag
  const launchImagePicker = async (useCamera) => {
    const options = {
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      quality: .9,
    };

    if (useCamera) {
      const permission = await ImagePicker.requestCameraPermissionsAsync();
      if (!permission.granted) {
        alert('Camera permission is required to take a photo.');
        return null;
      }
      return await ImagePicker.launchCameraAsync(options);
    }

    return await ImagePicker.launchImageLibraryAsync(options);
  };

  // maps an image slot (1, 2, or 3) to its state setters
  const getImageSetters = (target) => {
    switch (target) {
      case 1: return { setImage: setSelectedImage, setIsNewImageFn: setIsNewImage };
      case 2: return { setImage: setSelectedImage2, setIsNewImageFn: setIsNewImage2 };
      case 3: return { setImage: setSelectedImage3, setIsNewImageFn: setIsNewImage3 };
      default: return {};
    }
  };

  const pickImageAsync = async () => setPhotoSourceTarget(1);
  const pickImage2Async = async () => setPhotoSourceTarget(2);
  const pickImage3Async = async () => setPhotoSourceTarget(3);

  const handleTakePhoto = async () => {
    const target = photoSourceTarget;
    setPhotoSourceTarget(null);

    // ImagePicker has no camera support on web, so use the browser's webcam via WebCameraCapture instead
    if (Platform.OS === 'web') {
      setWebCameraTarget(target);
      return;
    }

    const { setImage, setIsNewImageFn } = getImageSetters(target);
    const result = await launchImagePicker(true);
    if (result && !result.canceled) {
      setImage(result.assets[0].uri);
      setIsNewImageFn(true);
    }
  };

  const handleChooseFromLibrary = async () => {
    const target = photoSourceTarget;
    setPhotoSourceTarget(null);

    const { setImage, setIsNewImageFn } = getImageSetters(target);
    const result = await launchImagePicker(false);
    if (result && !result.canceled) {
      setImage(result.assets[0].uri);
      setIsNewImageFn(true);
    } else {
      alert('You did not select an image.');
    }
  };

  const handleWebCameraCapture = (dataUri) => {
    if (webCameraTarget === 1) {
      setSelectedImage(dataUri);
      setIsNewImage(true);
    } else if (webCameraTarget === 2) {
      setSelectedImage2(dataUri);
      setIsNewImage2(true);
    } else if (webCameraTarget === 3) {
      setSelectedImage3(dataUri);
      setIsNewImage3(true);
    }
    setWebCameraTarget(null);
  };

  /* function to add new post to firestore */
  const handleSubmit = async (e) => {

    setIsSubmitDisabled(true);

    // console.log('handleSubmit');

    e.preventDefault()

    //console.log('refBar', refBar.current.getAddressText());

    var storageImageRef = "";
    var storageImageUrl = "";
    var storageImageRef2 = "";
    var storageImageUrl2 = "";
    var storageImageRef3 = "";
    var storageImageUrl3 = "";
    var storageImageWidth = null;
    var storageImageHeight = null;
    var storageImageWidth2 = null;
    var storageImageHeight2 = null;
    var storageImageWidth3 = null;
    var storageImageHeight3 = null;

    // console.log('refBar.current', refBar.current);
    
    if (selectedImage == null || selectedImage.length == 0)
    {
      setIsSubmitDisabled(false);
      alert('Add an image');
      return;
    }

    if (text == null || text.length == 0)
    {
      setIsSubmitDisabled(false);
      alert('Type a message');
      return;
    }

    // Validate business selection or GooglePlaces input
    let barName = '';
    if (businessesForUser && businessesForUser.length > 0) {
      // User has businesses - validate dropdown selection
      if (!selectedBusinessId) {
        setIsSubmitDisabled(false);
        alert('Select a bar');
        return;
      }
      // Get bar name from selected business
      const selectedBusiness = businessesForUser.find(b => b.id === selectedBusinessId);
      barName = selectedBusiness ? selectedBusiness.bar : '';
    } else {
      // Use GooglePlaces
      if (refBar.current.getAddressText() == null || refBar.current.getAddressText().length == 0)
      {
        setIsSubmitDisabled(false);
        alert('What bar are you at?');
        return;
      }
      //TODO? use googlePlacesDetails to get the bar name instead of using the text from the input field?
      barName = refBar.current.getAddressText().indexOf(",") > 0 ? 
        refBar.current.getAddressText().substring(0, refBar.current.getAddressText().indexOf(","))
        : refBar.current.getAddressText();
    }
    setBar(barName)

    // show activity indicator
    setAnimating(true);
    
    if (selectedImage != null && isNewImage) {
      var saveImageResult = await saveImage(selectedImage);
      storageImageRef = saveImageResult.storageImageRef;
      storageImageUrl = saveImageResult.storageImageUrl;
      var imageDims = await getImageDimensions(storageImageUrl);
      storageImageWidth = imageDims.width;
      storageImageHeight = imageDims.height;
    }
    if (selectedImage2 != null && isNewImage2) {
      var saveImageResult2 = await saveImage(selectedImage2);
      storageImageRef2 = saveImageResult2.storageImageRef;
      storageImageUrl2 = saveImageResult2.storageImageUrl;
      var imageDims2 = await getImageDimensions(storageImageUrl2);
      storageImageWidth2 = imageDims2.width;
      storageImageHeight2 = imageDims2.height;
    }
    if (selectedImage3 != null && isNewImage3) {
      var saveImageResult3 = await saveImage(selectedImage3);
      storageImageRef3 = saveImageResult3.storageImageRef;
      storageImageUrl3 = saveImageResult3.storageImageUrl;
      var imageDims3 = await getImageDimensions(storageImageUrl3);
      storageImageWidth3 = imageDims3.width;
      storageImageHeight3 = imageDims3.height;
    }

    // moved this to the add tag method so user sees the tag as it will be saved
    // // format tags - remove spaces, remove #, make lowercase
    // for (var i = 0; i < tags.length; i++) {
    //   tags[i] = tags[i].trim().toLowerCase().replace(/\s+/g, '');
    //   if (tags[i].startsWith('#')) {
    //     tags[i] = tags[i].substring(1);
    //   }
    // }

    try {
      // // Set with cityConverter - this does add or update (update if uniqueid already exists - does complete overwrite)
      // const ref = doc(db, "posts", "uniqueid").withConverter(postConverter);
      // await setDoc(ref, new Post(newText));

      // console.log("location:", location);

      let lat = location ? location.coords.latitude : null;
      let lng = location ? location.coords.longitude : null;
      let hash = location ? geofire.geohashForLocation([lat, lng]) : null;

      // if a user has selected a place from the google places api, use that location
      if (googlePlacesDetails) {
        // console.log('using googlePlacesDetails', googlePlacesDetails);
        lat = googlePlacesDetails.geometry.location.lat;
        lng = googlePlacesDetails.geometry.location.lng;
        hash = geofire.geohashForLocation([lat, lng]);
      }

      if (selectedBusinessId) {
        // get the business details for the selected business
        const businessDetails = await getBusinessDetails(selectedBusinessId);
        lat = businessDetails.latitude;
        lng = businessDetails.longitude;
        hash = businessDetails.geohash;
      }

      if (!isUpdating) {

        // get user image
        var userInfo = await getUserDataByUserId(window.localStorage.getItem('userId'));

        // console.log('userInfo', userInfo);

        // Add a new document with a generated id.
        const docRef = await addDoc(collection(db, 'Posts'), {
          comment: text,
          storageImageRef: storageImageRef,
          storageImageUrl: storageImageUrl,
          imageWidth: storageImageWidth,
          imageHeight: storageImageHeight,
          storageImageRef2: storageImageRef2,
          storageImageUrl2: storageImageUrl2,
          imageWidth2: storageImageWidth2,
          imageHeight2: storageImageHeight2,
          storageImageRef3: storageImageRef3,
          storageImageUrl3: storageImageUrl3,
          imageWidth3: storageImageWidth3,
          imageHeight3: storageImageHeight3,
          username: window.localStorage.getItem('username'),
          userId: window.localStorage.getItem('userId'),
          created: Timestamp.now(),
          latitude: lat,
          longitude: lng,
          geohash: hash,
          geohash2: hash.substring(0, 2),
          geohash3: hash.substring(0, 3),
          geohash4: hash.substring(0, 4),
          geohash5: hash.substring(0, 5),
          geohash6: hash.substring(0, 6),
          userInfo: {
            storageImageUrl: userInfo.storageImageUrl ? userInfo.storageImageUrl : '',
          },
          bar: barName,
          //tags: tags,
          tagsArray: tags,
          status: ['ok'],
          postType: selectedBusinessId ? 'bar' : 'user',
          businessId: selectedBusinessId ? selectedBusinessId : null,
          sendNotification: selectedBusinessId ? sendNotification : false,
        });
        // console.log("Document written with ID: ", docRef.id);

      }
      else {
       
        // console.log('update the post');

        try {
          const postRef = doc(db, "Posts", postId);

          // update the Post
          if (selectedImage != null && isNewImage)
          {
            await updateDoc(postRef, {
              storageImageRef: storageImageRef,
              storageImageUrl: storageImageUrl,
              imageWidth: storageImageWidth,
              imageHeight: storageImageHeight,
            });
          }

          if (selectedImage2 != null && isNewImage2) {
            await updateDoc(postRef, {
              storageImageRef2: storageImageRef2,
              storageImageUrl2: storageImageUrl2,
              imageWidth2: storageImageWidth2,
              imageHeight2: storageImageHeight2,
            });
          }
          else if (selectedImage2 == null && isNewImage2) {
            await updateDoc(postRef, {
              storageImageRef2: null,
              storageImageUrl2: null,
              imageWidth2: null,
              imageHeight2: null,
            })
          };

          if (selectedImage3 != null && isNewImage3) {
            await updateDoc(postRef, {
              storageImageRef3: storageImageRef3,
              storageImageUrl3: storageImageUrl3,
              imageWidth3: storageImageWidth3,
              imageHeight3: storageImageHeight3,
            });
          }
          else if (selectedImage3 == null && isNewImage3) {
            await updateDoc(postRef, {
              storageImageRef3: null,
              storageImageUrl3: null,
              imageWidth3: null,
              imageHeight3: null,
            })
          };

          await updateDoc(postRef, {
            comment: text,
            username: window.localStorage.getItem('username'),
            bar: barName,
            tagsArray: tags,
            latitude: lat,
            longitude: lng,
            geohash: hash,
            geohash2: hash.substring(0, 2),
            geohash3: hash.substring(0, 3),
            geohash4: hash.substring(0, 4),
            geohash5: hash.substring(0, 5),
            geohash6: hash.substring(0, 6),
          });
         
          // console.log('Post updated');
        } 
        catch (e) {
          // console.log("Error update the post: ", e);
        }
      }
     
      
      //onClose()
    } catch (err) {
      alert(err);
      setIsSubmitDisabled(false);
    }
    
    // hide activity indicator
    setAnimating(false);
    navigation.navigate({
      name: 'HomeScreen',
      params: { shouldRefresh: true },
      merge: true,
    });
  }

  // scrolls the GooglePlacesAutocomplete input into view so its results dropdown isn't hidden below the screen
  const scrollToBarInput = () => {
    setTimeout(() => {
      if (barContainerRef.current && scrollViewRef.current) {
        barContainerRef.current.measureLayout(
          findNodeHandle(scrollViewRef.current),
          (x, y) => {
            scrollViewRef.current.scrollTo({ y: y - 10, animated: true });
          },
          () => {}
        );
      }
    }, 100);
  };

  const handleTagAdd = async (e) => {
    // var newTagsArray = [].concat(tags);
    // newTagsArray.push(tag);
    // setTags(newTagsArray);

    if (!tag) {
      return;
    }

    var tagArray = tag.split(',');
    // console.log('tagArray', tagArray);

    let newTagsArray = null;
    for (var i = 0; i < tagArray.length; i++) {

      var newTag = tagArray[i].trim().toLowerCase().replace(/\s+/g, '');
      if (newTag.startsWith('#')) {
        newTag = newTag.substring(1);
      }

      if (newTag.length != 0 && tags.indexOf(newTag) == -1) {
        newTagsArray = newTagsArray == null ? tags.concat(newTag) : newTagsArray.concat(newTag);
      }
    }

    // console.log('newTagsArray', newTagsArray);
   
   
    setTags(newTagsArray);
    setTag('');
    //ref.current.value = "";

  }

  const handleTagRemove = async (tagToRemove) => {
    //const index = tags.indexOf(tagToRemove);
    //const newTagsArray = [].concat(tags.splice(index, 1));
    var temp = [... tags];
    const newTagsArray = [].concat(temp.filter((word) => word !== tagToRemove));

    setTags(newTagsArray);
    //setTag('');

    // var newTagsArray = [].concat(tags);
    // newTagsArray.push(tag);
    // setTags(newTagsArray);

    //const newTagsArray = tags.concat(tag);
    //setTags(newTagsArray);
    //setTag('');
  }

  // function renderTags() {
  //   const elements = [];
  //   tags.map(tag => elements.push((<Text key={tag} style={{marginRight: 10, fontSize: 12, color: '#674FE0' }} onPress={() => handleTagClick(tag)}>{tag}</Text>)));
  //   return elements;

  //   /*
  //   <Chip
  //                   label={barFilter}
  //                   color="white"
  //                   //backgroundColor="#674FE0"
  //                   variant="outlined"
  //                   onPress={() => clearBarFilter()}
  //                   style={styles.filter}
  //                   leading={props => <Icon name="close" style={{color: 'white'}} {...props}/>
  //   */
  // }

  const List = ({ tags }) => (
    // <ul>
      tags.map((item) => (
        // <li key={item}>{item}</li>
        <Chip
          key={item}
          label={item}
          color="white"
          //backgroundColor="#674FE0"
          variant="outlined"
          onPress={() => handleTagRemove(item)}
          style={styles.newTag}
          leading={props => <Icon name="close" style={{ color: 'white' }} {...props} />}
        />
      ))
    // </ul>
  );

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView style={styles.container} ref={scrollViewRef} keyboardShouldPersistTaps="handled">

        <View style={styles.imageContainer}>
          <TouchableWithoutFeedback onPress={pickImageAsync}>
            <View style={styles.imageContainer1}>
              <ImageViewer2
                placeholderImageSource={PlaceholderImage}
                selectedImage={selectedImage}
              />
            </View>
          </TouchableWithoutFeedback>
          {selectedImage && <Ionicons name="md-close-circle" size={30} color={"#674FE0"} onPress={() => setSelectedImage(null)} style={{ position: 'absolute', left: -8, top: -8 }} />}
          {/* <Button theme="secondary" label="Choose a photo (optional)" onPress={pickImageAsync} /> */}
        </View>
        <View style={{ flexDirection: 'row', paddingTop: 5}}>
          <Text style={{ fontSize: 12, color: '#674FE0' }} onPress={() => setShowChooseMorePhotos(!showChooseMorePhotos)}>Choose more photos (optional)</Text>
        </View>
        {showChooseMorePhotos &&
          <View style={styles.secondaryImageRow}>
            <TouchableWithoutFeedback onPress={pickImage2Async}>
              <View style={styles.imageContainer2}>
                <ImageViewer2
                  placeholderImageSource={PlaceholderImage}
                  selectedImage={selectedImage2}
                />
                {selectedImage2 && <Ionicons name="md-close-circle" size={30} color={"#674FE0"} onPress={() => { setSelectedImage2(null); setIsNewImage2(true); }} style={{ position: 'absolute', left: -8, top: -8 }} />}
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback onPress={pickImage3Async}>
              <View style={styles.imageContainer3}>
                <ImageViewer2
                  placeholderImageSource={PlaceholderImage}
                  selectedImage={selectedImage3}
                />
                {selectedImage3 && <Ionicons name="md-close-circle" size={30} color={"#674FE0"} onPress={() => { setSelectedImage3(null); setIsNewImage3(true); }} style={{ position: 'absolute', left: -8, top: -8 }} />}
              </View>
            </TouchableWithoutFeedback>
          </View>
        }
        <View style={styles.textContainer}>
          <TextInput
            style={{ height: 80, width: '100%', backgroundColor: '#fff', padding: 5, marginTop: 5, marginBottom: 5 }}
            placeholder="What's happening?"
            placeholderTextColor="gray"
            onChangeText={newText => setText(newText)}
            defaultValue={text}
            numberOfLines={5}
            textAlignVertical={"top"}
            textBreakStrategy={"highQuality"}
            multiline={true}
            maxLength={500}
          />
          {/* Show dropdown if user has businesses */}
          {businessesForUser && businessesForUser.length > 0 ? (
            <Picker
              selectedValue={selectedBusinessId}
              onValueChange={(itemValue) => setSelectedBusinessId(itemValue)}
              style={{ height: 40, width: '100%', backgroundColor: '#fff', marginTop: 5 }}
            >
              <Picker.Item label="Select the business" value="" />
              {businessesForUser.map((business) => (
                <Picker.Item key={business.id} label={business.bar} value={business.id} />
              ))}
            </Picker>
          ) : (
            /* Show GooglePlacesAutocomplete if no businesses */
            <View ref={barContainerRef}>
              <GooglePlacesAutocomplete
                placeholder='What bar, brewery?'
                ref={refBar}            
                fetchDetails={true}
                textInputProps={{
                  placeholderTextColor: 'gray',
                  size: 14,
                  font: 'BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  onFocus: scrollToBarInput
                }}
                minLength={2} // minimum length of text to search
                onPress={(data, details = null) => {
                  // 'details' is provided when fetchDetails = true
                  // console.log('data, details', data, details);
                  setGooglePlacesDetails(details);
                }}
                query={{
                  //key: 'AIzaSyBQmpsFNXkLFhuWyxeJMjUW-pk7O4xOHN4',
                  language: 'en',
                  lat: location ? location.coords.latitude : null,
                  lng: location ? location.coords.longitude : null,
                }}
                requestUrl={{
                  useOnPlatform: 'web', // or "all"
                  url:
                    'https://us-central1-atabar-d7693.cloudfunctions.net/placesApiSearch', // or any proxy server that hits https://maps.googleapis.com/maps/api
                  // headers: {
                  //   Authorization: `an auth token`, // if required for your proxy
                  // },
                }}
              />
            </View>
          )}
          {businessesForUser && businessesForUser.length > 0 && !isUpdating &&
            <Pressable style={styles.notifyRow} onPress={() => setSendNotification(!sendNotification)}>
              <Ionicons
                name={sendNotification ? 'checkbox' : 'square-outline'}
                size={24}
                color="#674FE0"
              />
              <Text style={styles.notifyLabel}>Notify users who favorited this bar</Text>
            </Pressable>
          }
          <View style={{ flexDirection: 'row' }}>
            <TextInput
              style={{ height: 40, width: '50%', backgroundColor: '#fff', padding: 5, marginTop: 5 }}
              placeholder="Add tag(s)?"
              placeholderTextColor="gray"
              onChangeText={newText => setTag(newText.toLowerCase())}
              value={tag}
              textAlignVertical={"center"}
              maxLength={100}
              ref={ref}
            />
            <IconButton
              icon={props => <Icon name="plus" {...props} />}
              color="white"
              onPress={handleTagAdd}
              style={{ backgroundColor: '#674FE0', width: 40, height: 40, alignSelf: 'center', marginLeft: 5  }}
            />
          </View>
        </View>
        <View style={styles.tagsContainer}>
          {tags ? <List tags={tags} /> : <></>}
        </View>
        <View style={styles.postbuttoncontainer}>
          {/* <View> */}
            <ActivityIndicator style={{ position: 'absolute', bottom: '50%', right: '50%',}} size="large" color="#ffd33d" animating={animating} hidesWhenStopped={true} />
          {/* </View> */}
          {isUpdating == false &&
            <Button theme="primary" label="Post" onPress={handleSubmit} isDisabled={isSubmitDisabled} />
          }
          {isUpdating == true &&
            <Button theme="primary" label="Save" onPress={handleSubmit} isDisabled={isSubmitDisabled} />
          }
          <StatusBar style="auto" />
        </View>
        {/* <View style={styles.footerContainer}>

      </View> */}
      </ScrollView>
      <ConfirmModal
        message={"Are you sure you want to delete your post?"}
        visible={isDeleteConfirmVisible}
        dismiss={closePopup}
        confirmDelete={confirmDeletePost}
      ></ConfirmModal>
      <WebCameraCapture
        visible={webCameraTarget !== null}
        onCapture={handleWebCameraCapture}
        onClose={() => setWebCameraTarget(null)}
      />
      <PhotoSourceModal
        visible={photoSourceTarget !== null}
        onTakePhoto={handleTakePhoto}
        onChooseFromLibrary={handleChooseFromLibrary}
        onClose={() => setPhotoSourceTarget(null)}
      />
    </SafeAreaView>
  );
}

// todo: old view, delete
// function PostScreen() {
//     return (
//         <View style={styles.container}>
//             <View style={styles.imageContainer}>
//                 <ImageViewer
//                     placeholderImageSource={PlaceholderImage}
//                     selectedImage={selectedImage}
//                 />
//             </View>
//             <View style={styles.footerContainer}>
//                 <Button theme="primary" label="Choose a photo" onPress={pickImageAsync} />
//                 <Button label="Use this photo" />
//             </View>
//             <StatusBar style="auto" />
//         </View>
//     );
// }

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F2F2F2',
    paddingTop: 5,
    paddingLeft: 20,
    paddingRight: 20
    //alignItems: 'center',
  },
  imageContainer: {
    width: '100%',
  },
  imageContainer1: {
    width: '100%',
    backgroundColor: '#E0CD67',
  },
  imageContainer2: {
    flex: 1,
    width: '100%',
    backgroundColor: '#E0CD67',
    marginRight: 5,
  },
  imageContainer3: {
    flex: 1,
    width: '100%',
    backgroundColor: '#E0CD67',
    marginLeft: 5,
  },
  secondaryImageRow: {
    width: '100%',
    flexDirection: 'row',
    // prevents the row from stretching both photos to match the taller one's height
    alignItems: 'flex-start',
    marginTop: 10,
  },
  textContainer: {
    flex: 1,
    flexDirection: 'column',
    //backgroundColor: 'pink',
    //alignItems: 'center',
    //paddingBottom: 10,
  },
  tagsContainer: {
    //flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 5,
    //backgroundColor: 'pink',
    //alignItems: 'center',
    //paddingBottom: 10,
  },
  postbuttoncontainer: {    
    //flex: 1/2,
    //direction is column because of the activity indicator taking up space even when off
    flexDirection: 'column',
    //backgroundColor: 'yellow',
    //alignContent: 'top',
    paddingTop: 10,
    alignItems: 'center',
  },
  newTag: {
    alignSelf: 'center',
    backgroundColor: "#674FE0",
  },
  notifyRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  notifyLabel: {
    fontSize: 14,
    color: '#333',
    marginLeft: 8,
  }
  // footerContainer: {
  //   flex: 1,
  //   flexDirection: 'row',
  //   backgroundColor: 'green',
  // }
});
